<template>
  <v-parallax
    class="w-100"
    height="300"
    :src="backgroundImage(market.key, sector)"
  >
    <div 
      class="has-background"
      :style="headBackground"
      v-if="typeScreen === 'sectors'"
    />
    <v-container fill-height v-if="typeScreen === 'sectors'">
      <v-row justify="center" align-center my-4>
        <v-col cols="12" class="white--text">
          <h1 v-if="title" class="display-3 mb-2">{{ headTitle }}</h1>
          <div class="v-row-title d-flex align-center mb-0">
            <market-icons :items="[market.key]" />
            <p class="v-row-title title mt-1 ml-2 mb-0">
              <span class="ml-0" v-if="market.key !== 'null'">
                {{ i18nTermsGroupsLabel('markets', market.key) }}
              </span> <span class="subtitle-1 font-weight-light ml-0">
                {{ $tc('theme.documentCount', [sector.count]) }}
              </span>
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div 
      class="has-background"
      :style="`background:${market.color}`"
      v-if="typeScreen === 'markets'"
    />
    <v-container fill-height v-if="typeScreen === 'markets'">
      <v-row justify="center" align-center my-4>
        <v-col cols="12" class="white--text">
          <h1 v-if="title" class="display-3 mb-2">{{ headTitle }}</h1>
          <div class="v-row-title display-1 d-flex align-center mb-0">
            <market-icons :items="[market.key]" />
            <p class="ml-2 mb-0 subtitle-1 font-weight-light">
              {{ $tc('theme.documentCount', [market.count]) }}
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-parallax>
</template>
<script>
import Mixins from '@/core/mixins'
import MarketIcons from '@/components/file/Markets'
export default {
  name: "HeadbandCustom",
  mixins: [ Mixins ],
  data () {
    return {
      documents: [],
      hasBackgroundImage: false
    }
  },
  components: {
    MarketIcons
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    overline: {
      type: String,
      default: ""
    },
    typeScreen: {
      type: String,
      default: "sectors"
    },
    market: {
      type: Object,
      default: () => {}
    },
    sector: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    headBackground () {
      return `background:${this.sector.color}`
    },

    headTitle () {
      const lang = `name_${this.$i18n.locale.split('-')[0]}`
      if (this.typeScreen === 'markets') {
        return this.market[lang]
      } else  {
        return this.sector[lang]
      }
    },
  },
  methods: {
    backgroundImage (market, sector) {
      let sectorObj = sector && sector.id ? sector.id : null

      if (sector === undefined || sector === 'Empty' || sector === 'EMPTY') {
        const sectors = this.$store.getters["home/termsType"]('sectors').filter(f => f.market === this.market.key)
        sectorObj = sectors.map(s => s.id).map((a) => [Math.random(),a]).sort((a,b) => a[0]-b[0]).map((a) => a[1])[0]
      }

      if (sector && (sector.id === 'Empty' || sector.id === 'EMPTY')) {
        const sectors = this.$store.getters["home/termsType"]('sectors').filter(f => f.market === this.market.key)
        sectorObj = sectors.map(s => s.id).map((a) => [Math.random(),a]).sort((a,b) => a[0]-b[0]).map((a) => a[1])[0]
      }

      let defaultImage = require(`@/assets/banners/Banner_FL_HygieneAgrolimentaire.png`)
      if (market !== 'FL') {
        defaultImage = require(`@/assets/banners/Banner_${ market }-${ sectorObj.replace(/[^a-zA-Z0-9\- ]/g, "") }.png`) 
      }

      if (typeof defaultImage !== 'undefined') {
        this.hasBackgroundImage = true
        return defaultImage
      } else {
        const defaultImage = require('@/assets/Banner_default.png')
        this.hasBackgroundImage = false
        return defaultImage
      }
    }
  }
}
</script>
<style scoped>
.has-background {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  opacity: .5;
}
</style>
